import Stack from '@mui/material/Stack';
import '../App.css';
import GreenLightIcon from './GreenLightIcon';
import RedLightIcon from './RedLightIcon';
import { Styles } from '../Styles';

const GreenRedLightIcon = (props) => {
    const onOffBit = props.onOffBit;
    const onLabel = props.onLabel;
    const offLabel = props.offLabel;

    return (
        <>
            {onOffBit === '1' && (
                <Stack direction='row' sx={{ ...Styles.lightDisplay }}>
                    <GreenLightIcon />
                    {onLabel}
                </Stack>
            )}
            {onOffBit === '0' && (
                <Stack direction='row' sx={{ ...Styles.lightDisplay }}>
                    <RedLightIcon />
                    {offLabel}
                </Stack>
            )}
        </>
    );
};

export default GreenRedLightIcon;